import refs from "./refs";
import { hideBackdrop } from "./utils";

let selectedFilterUrl = null;

const setCasesLoadingState = (input, trigger = null) => {
    const item = input ? input.closest('.filter-list__item') : null;

    $('.filter-list__item').removeClass('is-loading');
    $('.buttons-list__button').removeClass('is-loading').prop('disabled', false);

    if (item) {
        item.classList.add('is-loading');
    }

    if (trigger) {
        trigger.addClass('is-loading').prop('disabled', true);
    }

    $('#cases .hero-content').attr('aria-busy', 'true').addClass('is-loading');
};

const resetCasesLoadingState = () => {
    $('.filter-list__item').removeClass('is-loading');
    $('.buttons-list__button').removeClass('is-loading').prop('disabled', false);
    $('#cases .hero-content').removeAttr('aria-busy').removeClass('is-loading');
};

const syncFilterStateFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const activeCategory = params.get('case_category') || '0';

    $('.filter-list input.filter-list__input').each(function () {
        this.checked = this.value === activeCategory;
    });

    const checkedMobileInput = $('.filter-list input.filter-list__input:checked').filter('[name^="mob-"]');
    selectedFilterUrl = checkedMobileInput.length ? checkedMobileInput[0].dataset.url || null : null;

    $('.buttons-list__button.clean').toggle(activeCategory !== '0');
    resetCasesLoadingState();
};

syncFilterStateFromUrl();

window.addEventListener('pageshow', syncFilterStateFromUrl);

const navigateToFilter = (input) => {
    const targetUrl = input.dataset.url;

    if (!targetUrl) {
        return;
    }

    if (targetUrl === window.location.href) {
        return;
    }

    setCasesLoadingState(input);

    window.setTimeout(() => {
        window.location.href = targetUrl;
    }, 180);
};

$('.filter-list input.filter-list__input').on('change', function () {
    selectedFilterUrl = this.dataset.url || null;

    if (this.name.startsWith('desktop-')) {
        navigateToFilter(this);
    }

    $('.buttons-list__button.clean').toggle($(this).val() !== '0');
});

$('.buttons-list__button.clean').on('click', function () {
    const allInput = $('.filter-list input[value="0"]').filter('[name^="mob-"]');

    if (!allInput.length) {
        return;
    }

    allInput.prop('checked', true);
    selectedFilterUrl = allInput[0].dataset.url || null;
    $(this).hide();
});

$('.buttons-list__button').not('.clean').on('click', function () {
    const checkedInput = $('.filter-list input.filter-list__input:checked').filter('[name^="mob-"]');
    const targetUrl = selectedFilterUrl || (checkedInput.length ? checkedInput[0].dataset.url : null);

    if (targetUrl) {
        setCasesLoadingState(checkedInput[0], $(this));
        hideBackdrop(refs.filterBackdrop);

        window.setTimeout(() => {
            window.location.href = targetUrl;
        }, 180);
    }
});
